// Generated by tools/bake-levels.ts (pnpm levels:bake): do not edit by hand.
import { loadLevel, type LevelDef } from '../../levelSchema';
import l001 from './001.json';
import l002 from './002.json';
import l003 from './003.json';
import l004 from './004.json';
import l005 from './005.json';
import l006 from './006.json';
import l007 from './007.json';
import l008 from './008.json';
import l009 from './009.json';
import l010 from './010.json';
import l011 from './011.json';
import l012 from './012.json';
import l013 from './013.json';
import l014 from './014.json';
import l015 from './015.json';
import l016 from './016.json';
import l017 from './017.json';
import l018 from './018.json';
import l019 from './019.json';
import l020 from './020.json';
import l021 from './021.json';
import l022 from './022.json';
import l023 from './023.json';
import l024 from './024.json';
import l025 from './025.json';
import l026 from './026.json';
import l027 from './027.json';
import l028 from './028.json';
import l029 from './029.json';
import l030 from './030.json';
import l031 from './031.json';
import l032 from './032.json';
import l033 from './033.json';
import l034 from './034.json';
import l035 from './035.json';
import l036 from './036.json';
import l037 from './037.json';
import l038 from './038.json';
import l039 from './039.json';
import l040 from './040.json';
import l041 from './041.json';
import l042 from './042.json';
import l043 from './043.json';
import l044 from './044.json';
import l045 from './045.json';
import l046 from './046.json';
import l047 from './047.json';
import l048 from './048.json';
import l049 from './049.json';
import l050 from './050.json';
import l051 from './051.json';
import l052 from './052.json';
import l053 from './053.json';
import l054 from './054.json';
import l055 from './055.json';
import l056 from './056.json';
import l057 from './057.json';
import l058 from './058.json';
import l059 from './059.json';
import l060 from './060.json';
import l061 from './061.json';
import l062 from './062.json';
import l063 from './063.json';
import l064 from './064.json';
import l065 from './065.json';
import l066 from './066.json';
import l067 from './067.json';
import l068 from './068.json';
import l069 from './069.json';
import l070 from './070.json';
import l071 from './071.json';
import l072 from './072.json';
import l073 from './073.json';
import l074 from './074.json';
import l075 from './075.json';
import l076 from './076.json';
import l077 from './077.json';
import l078 from './078.json';
import l079 from './079.json';
import l080 from './080.json';
import l081 from './081.json';
import l082 from './082.json';
import l083 from './083.json';
import l084 from './084.json';
import l085 from './085.json';
import l086 from './086.json';
import l087 from './087.json';
import l088 from './088.json';
import l089 from './089.json';
import l090 from './090.json';
import l091 from './091.json';
import l092 from './092.json';
import l093 from './093.json';
import l094 from './094.json';
import l095 from './095.json';
import l096 from './096.json';
import l097 from './097.json';
import l098 from './098.json';
import l099 from './099.json';
import l100 from './100.json';
import l101 from './101.json';
import l102 from './102.json';
import l103 from './103.json';
import l104 from './104.json';
import l105 from './105.json';
import l106 from './106.json';
import l107 from './107.json';
import l108 from './108.json';
import l109 from './109.json';
import l110 from './110.json';
import l111 from './111.json';
import l112 from './112.json';
import l113 from './113.json';
import l114 from './114.json';
import l115 from './115.json';
import l116 from './116.json';
import l117 from './117.json';
import l118 from './118.json';
import l119 from './119.json';
import l120 from './120.json';
import l121 from './121.json';
import l122 from './122.json';
import l123 from './123.json';
import l124 from './124.json';
import l125 from './125.json';
import l126 from './126.json';
import l127 from './127.json';
import l128 from './128.json';
import l129 from './129.json';
import l130 from './130.json';
import l131 from './131.json';
import l132 from './132.json';
import l133 from './133.json';
import l134 from './134.json';
import l135 from './135.json';
import l136 from './136.json';
import l137 from './137.json';
import l138 from './138.json';
import l139 from './139.json';
import l140 from './140.json';
import l141 from './141.json';
import l142 from './142.json';
import l143 from './143.json';
import l144 from './144.json';
import l145 from './145.json';
import l146 from './146.json';
import l147 from './147.json';
import l148 from './148.json';
import l149 from './149.json';
import l150 from './150.json';
import l151 from './151.json';
import l152 from './152.json';
import l153 from './153.json';
import l154 from './154.json';
import l155 from './155.json';
import l156 from './156.json';
import l157 from './157.json';
import l158 from './158.json';
import l159 from './159.json';
import l160 from './160.json';

/** Baked campaign levels (tools/bake-levels.ts), validated at load, in level order. */
export const CAMPAIGN_LEVELS: readonly LevelDef[] = [
  l001,
  l002,
  l003,
  l004,
  l005,
  l006,
  l007,
  l008,
  l009,
  l010,
  l011,
  l012,
  l013,
  l014,
  l015,
  l016,
  l017,
  l018,
  l019,
  l020,
  l021,
  l022,
  l023,
  l024,
  l025,
  l026,
  l027,
  l028,
  l029,
  l030,
  l031,
  l032,
  l033,
  l034,
  l035,
  l036,
  l037,
  l038,
  l039,
  l040,
  l041,
  l042,
  l043,
  l044,
  l045,
  l046,
  l047,
  l048,
  l049,
  l050,
  l051,
  l052,
  l053,
  l054,
  l055,
  l056,
  l057,
  l058,
  l059,
  l060,
  l061,
  l062,
  l063,
  l064,
  l065,
  l066,
  l067,
  l068,
  l069,
  l070,
  l071,
  l072,
  l073,
  l074,
  l075,
  l076,
  l077,
  l078,
  l079,
  l080,
  l081,
  l082,
  l083,
  l084,
  l085,
  l086,
  l087,
  l088,
  l089,
  l090,
  l091,
  l092,
  l093,
  l094,
  l095,
  l096,
  l097,
  l098,
  l099,
  l100,
  l101,
  l102,
  l103,
  l104,
  l105,
  l106,
  l107,
  l108,
  l109,
  l110,
  l111,
  l112,
  l113,
  l114,
  l115,
  l116,
  l117,
  l118,
  l119,
  l120,
  l121,
  l122,
  l123,
  l124,
  l125,
  l126,
  l127,
  l128,
  l129,
  l130,
  l131,
  l132,
  l133,
  l134,
  l135,
  l136,
  l137,
  l138,
  l139,
  l140,
  l141,
  l142,
  l143,
  l144,
  l145,
  l146,
  l147,
  l148,
  l149,
  l150,
  l151,
  l152,
  l153,
  l154,
  l155,
  l156,
  l157,
  l158,
  l159,
  l160,
].map((file) => loadLevel(file));
